export class LevelCounter {
  private element: HTMLDivElement;
  private level = 1;
  private lastUpdateTime: number;
  private elapsedTime = 0;
  private running = false;
  private bestTime: number | null = null;

  constructor() {
    this.element = document.createElement('div');
    this.element.id = 'level-counter';
    this.element.style.position = 'absolute';
    this.element.style.top = '10px';
    this.element.style.left = '10px';
    this.element.style.color = '#fff';
    this.element.style.fontFamily = 'monospace';
    this.element.style.fontSize = '24px';
    this.element.style.textShadow = '2px 2px 4px #000';
    this.element.style.pointerEvents = 'none';

    document.body.appendChild(this.element);
    this.lastUpdateTime = performance.now();
    this.render();
  }

  increment(): void {
    this.level++;
    this.resetTimer();
  }

  setLevel(level: number): void {
    this.level = level;
    this.resetTimer();
  }

  setBestTime(time: number | null): void {
    this.bestTime = time;
    this.render();
  }

  resetTimer(): void {
    this.lastUpdateTime = performance.now();
    this.elapsedTime = 0;
    this.running = false;
  }

  getLevel(): number {
    return this.level;
  }

  getElapsedTime(): number {
    return this.elapsedTime;
  }

  update(isRunning: boolean): void {
    const now = performance.now();

    if (isRunning) {
      if (this.running) {
        // Add elapsed time since last update
        this.elapsedTime += now - this.lastUpdateTime;
      }
      this.running = true;
    } else {
      this.running = false;
    }

    this.lastUpdateTime = now;
    this.render();
  }

  private formatTime(ms: number): string {
    const totalSeconds = ms / 1000;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds % 60);
    const tenths = Math.floor((totalSeconds * 10) % 10);
    return `${minutes}:${seconds.toString().padStart(2, '0')}.${tenths}`;
  }

  private render(): void {
    const timeStr = this.formatTime(this.elapsedTime);
    let display = `Level ${this.level} - ${timeStr}`;

    if (this.bestTime !== null) {
      const bestStr = this.formatTime(this.bestTime);
      display += ` (Best: ${bestStr})`;
    }

    this.element.textContent = display;
  }

  destroy(): void {
    this.element.remove();
  }
}
